import React from 'react';
import ReactToolTip from 'react-tooltip';
import {unread, unread_fallback} from "../../../../../constants/asseturls";
import {detect} from "detect-browser";

/**
 * A component that displays a small
 * unread notification on the recording card
 */
const UnreadAlert = () => {
    const browser = detect();
    let unread_inline_notif_url = unread_fallback;
    switch (browser && browser.name) {
        case 'chrome':
        case 'firefox':
        case 'opera':
        case 'safari':
            unread_inline_notif_url = unread;
            break;
        default:
            break;
    }
    return (
        <div>
            <img
                src={unread_inline_notif_url}
                className="unread"
                alt="unread recording"
                data-tip
                data-for="unreadRecordingTip"
            />
            <ReactToolTip id="unreadRecordingTip" type="info">
                <span>You have not viewed this recording</span>
            </ReactToolTip>
        </div>
    );
};

export default UnreadAlert;



// WEBPACK FOOTER //
// ./src/components/unit/recordings/recordingcard/information/UnreadAlert.jsx